module.exports = __webpack_public_path__ + "static/media/thats-it-new-english.3845b184.svg";